import React, { FC } from 'react';
//import Dotdotdot from 'react-dotdotdot';

interface Props {
    columns: { id: string; type?: string; cellStyle: string }[];
    colorColumn?: string;
    //row: { [key: string]: any };
    row: any;
}

const SimpleTable: FC<Props> = ({ columns, row, colorColumn }: Props) => {
    if (!row) {
        return null;
    }

    return (
        <div>
            {columns.map((column: { id: string; type?: string; cellStyle: string }, key) => {
                if (row.totalColumn && !row[column.id]) {
                    return null;
                }
                let styleCell: any = {
                    minHeight: 50,
                    fontSize: 14,
                    alignItems: 'center',
                    minWidth: '100px',
                    textAlign: 'center',
                };
                if (row.totalColumn) {
                    styleCell = {
                        minHeight: 50,
                        fontSize: 14,
                        alignItems: 'center',
                        minWidth: '100px',
                        textAlign: 'center',
                        background: 'rgb(241, 241, 241)',
                    };
                }
                return (
                    <div
                        style={
                            column.id === 'description'
                                ? {
                                      minHeight: 50,
                                      fontSize: 13,
                                      maxHeight: '50px',
                                      alignItems: 'start',
                                      overflow: 'auto',
                                      minWidth: '100px',
                                      textAlign: 'center',
                                  }
                                : styleCell
                        }
                        className={'border-secondary  d-flex justify-content-center  border border-bottom-1'}
                        key={`tddd-${key}`}
                    >
                        {row[`${column?.id}`]}
                    </div>
                );
            })}
        </div>
    );
};

export default SimpleTable;
